import TextField, { TextFieldProps } from '@mui/material/TextField';
import styled from '@emotion/styled';

type CustomTextFieldProps = TextFieldProps & {
  design?: {
    themeColor?: string;
  };
};

const CustomTextFieldDesign = styled(TextField)<CustomTextFieldProps>(({ design }) => ({
  
  '& .MuiInputLabel-asterisk': {
    color: 'red', // Set the asterisk color to red
  },
  '& label.Mui-focused': {
    color: design?.themeColor,
  },
  '& label': {
    color: '#9ca3af', // Set your placeholder color here
    fontWeight: 'normal'
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'white',
    '& fieldset': {
      borderColor: '#d1d5db'
    },
    '&:hover fieldset': {
      borderColor: '#d1d5db',
      borderWidth: '1px'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#d1d5db',
      borderWidth: '1px'
    }
  },
}));

export const CustomTextField: React.FC<CustomTextFieldProps> = (props) => {
  return <CustomTextFieldDesign fullWidth variant="outlined" {...props} />;
};
